/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Zns_Purpose_UnknownInputs */

const vi_error_zns_purpose_unknown = /** @type {(inputs: Error_Zns_Purpose_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có mục đích gửi này.`)
};

/**

* @param {Error_Zns_Purpose_UnknownInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zns_purpose_unknown = /** @type {((inputs?: Error_Zns_Purpose_UnknownInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zns_Purpose_UnknownInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zns_purpose_unknown(inputs)
});